<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img src="@/assets/jiejue/custom/dedicated-line-hero-banner.svg" alt="" srcset="" style="width: 100%" @load="loaded = true" :class="{ show: loaded }" class="top_img">
      <div class="ai-hero-title">运营商安全解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a class="product-tab" :class="{ active: activeTab === 'background' }" href="#background" @click.prevent="scrollTo('background')">需求背景</a>
      <a class="product-tab" :class="{ active: activeTab === 'challenges' }" href="#challenges" @click.prevent="scrollTo('challenges')">业务挑战</a>
      <a class="product-tab" :class="{ active: activeTab === 'scenarios' }" href="#scenarios" @click.prevent="scrollTo('scenarios')">场景应用</a>
      <a v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" class="product-tab" :class="{ active: activeTab === 'architecture' }" href="#architecture" @click.prevent="scrollTo('architecture')">部署示意图</a>
      <a class="product-tab" :class="{ active: activeTab === 'advantages' }" href="#advantages" @click.prevent="scrollTo('advantages')">方案优势</a>
      <a class="product-tab" :class="{ active: activeTab === 'cases' }" href="#cases" @click.prevent="scrollTo('cases')">典型案例</a>
    </nav>

    <div class="product-body">
    <section id="background" class="product-section section-row ai-platform-block" :class="{ 'animate-in': backgroundVisible }">
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            运营商安全解决方案基于安全资源池的能力与运营商大网实现对接，将政企专线用户的流量引流到安全资源池进行统一安全防护，为政企专线用户提供安全防护、监测、运营等服务，提高专线增值能力。
          </p>
        </div>
      </div>
    </section>

    <section id="challenges" class="product-section section-row ai-platform-block" :class="{ 'animate-in': challengesVisible }">
      <div class="section-title">业务挑战</div>
      <div class="section-content">
        <div class="grid-2">
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/DedicatedLineSecurity/1.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">防护部署与专线适配性不足</div>
              <div class="card-desc">防护部署与专线适配性不足，传统专线基础防护薄弱，高端防护设备适配难度大、成本高，且缺乏定制化防护方案。</div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/DedicatedLineSecurity/2.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">防护运维成本高、专业度不足</div>
              <div class="card-desc">防护运维成本高、专业度不足，中小企业缺乏专业运维团队，委托运维又会增加成本，导致防护设备难以发挥作用。</div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/DedicatedLineSecurity/3.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">多专线协同防护统一性欠缺</div>
              <div class="card-desc">多专线协同防护统一性欠缺，多网点专线防护标准、策略不一，无法实现全局安全管控。</div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/DedicatedLineSecurity/4.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">防护升级与风险迭代不同步</div>
              <div class="card-desc">防护升级与风险迭代不同步，专线防护策略和设备配置固定，升级需中断业务，且服务商技术更新滞后，难以抵御新型攻击。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="scenarios" class="product-section section-row ai-platform-block" :class="{ 'animate-in': scenariosVisible }">
      <div class="section-title">场景应用</div>
      <div class="section-content">
        <div class="scenarios">
          <div class="scenario-text">
            <div class="scenario-item">
              <div class="item-title">安全专线场景是与运营商一起打造运营商安全专线服务，目前专线存在的痛点如下</div>
              <div class="item-desc">
                <div>1.网络安全法和等级保护条例，明确了国内所有网络运营者均需要履行的安全保护义务；</div>
                <div>2.运营商传统固网专线业务萎缩，需要借力网络安全能力，拓展新的收入增长空间；</div>
                <div>3.目前无法感知来自互联网的威胁；同时有什么类型的攻击，针对我哪些暴露在互联网上的资产；</div>
                <div>4.不知道专线带宽的使用情况，不知道专线流量的组成，网速缓慢不知道原因。</div>
              </div>
            </div>
          </div>
          <img src="@/assets/jiejue/DedicatedLineSecurity/right.svg" alt="" style="width: 50%; border-radius: 4px;" class="mobile-hidden-img">
        </div>
      </div>
    </section>

    <section v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" id="architecture" class="product-section section-row ai-platform-block" :class="{ 'animate-in': architectureVisible }">
      <div class="section-title">部署示意图</div>
      <div class="section-content">
        <img src="@/assets/solutions/deploy/dedicated-line.svg" alt="部署示意图" class="architecture-image">
      </div>
    </section>

    <section id="advantages" class="product-section section-row advantages ai-platform-block" :class="{ 'animate-in': advantagesVisible }">
      <div class="section-title">方案优势</div>
      <div class="section-content">
        <div class="grid-4">
          <div class="adv-card">
            <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge"/>
            <div class="adv-title">攻击可视化</div>
            <div class="adv-desc">让互联网攻击威胁可视化，为客户提供一个在线的针对互联网专线的入侵检测系统，无须本地化部署</div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge"/>
            <div class="adv-title">流量可视化</div>
            <div class="adv-desc">让专线流量情况可视化，为客户提供一个在线的针对互联网专线的流量分析系统，无须本地化部署</div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge"/>
            <div class="adv-title">漏洞检测</div>
            <div class="adv-desc">每周自动为客户网站执行漏洞扫描，并将结果呈现在平台页面中。相当于获取了一台在线的WEB漏扫设备</div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge"/>
            <div class="adv-title">安全防护</div>
            <div class="adv-desc">无需部署硬件，开通策略即可获取网站防护、上网行为、安全检测等安全防护能力</div>
          </div>
        </div>
      </div>
    </section>

    <section id="cases" class="product-section section-row ai-platform-block" :class="{ 'animate-in': casesVisible }">
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某大型运营商承担着全省的专线运营服务，专线客户涵盖政府、企业、金融等多个行业，业务规模庞大，日常需处理大量的专线装维、售后支撑和安全事件处置工作。当前，运营商面临的核心问题是：专线安全告警量大，冗余告警占比高，运维人员需花费大量时间进行人工研判，处置效率低下；安全报告专业性强，部分客户无法准确理解报告内容，难以快速落实整改；专线安全运营缺乏智能化支撑，常规场景的处置仍需人工介入，运维成本居高不下；31省专线的安全状态无法实现统一监控和协同处置，存在安全管理盲区。为提升专线安全运营效率，降低运维成本，提升客户满意度，运营商引入专线安全运营平台解决方案，构建“AI+安全运营”的智能化运营体系。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 告警冗余率高，处置效率低：专线安全告警量大，冗余告警占比高，运维人员需人工筛选有效告警，研判处置效率低下，无法快速响应客户需求；</li>
              <li>2. 安全报告解读难度大：专业安全报告包含大量技术术语，非专业客户难以理解，导致整改落实不及时，客户满意度偏低；</li>
              <li>3. 运营智能化程度低：常规安全事件处置、报告解读等工作需人工介入，运维成本高，且易出现人为失误；</li>
              <li>4. 多区域协同管控难：31省专线分布广泛，安全状态分散，无法实现统一监控、协同处置，存在安全管理盲区。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 引入AI告警智能降噪：在专线安全运营平台中集成AI大模型，构建多层级告警过滤机制，通过AI算法自动识别冗余告警、误报告警，在保障重要告警无遗漏的前提下，将冗余告警量减少超90%，大幅降低运维人员的研判负担，提升告警处置效率。</li>
              <li>2. 实现安全报告智能解读：依托AI语义分析技术与行业知识库，开发安全报告智能解读功能，将专业报告转化为通俗化内容，同步输出精准的整改建议，支持个性化咨询响应，解决客户看不懂专业报告、整改落实不及时的痛点，提升客户满意度。</li>
              <li>3. 构建智能化运营闭环：建立“运行监测-智能迭代-人机协作-数据反馈”的数智化运营闭环，通过AI自主学习驱动常规场景（如普通告警处置、报告解读）的高效响应；针对复杂场景，由党员骨干牵头提供人机协作辅助支持，同时收集场景化数据，反哺AI模型训练，推动智能能力持续迭代。</li>
              <li>4. 搭建统一协同管控平台：整合31省专线安全数据，构建统一的专线安全运营管控平台，实现所有专线安全状态的实时监控、故障告警、协同处置，打破区域管理壁垒；同时支撑客户装维、售后支撑等工作，实现专线安全运营的集约化、智能化管理，截至项目落地，已支撑客户装维近4000起，处理售后支撑近2300起，大幅提升运营效率。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
import dedicatedLineBanner from '@/assets/jiejue/custom/dedicated-line-hero-banner.svg'
const loaded = ref(false)

// 这里写即可，代替 export default
defineOptions({
  banner: dedicatedLineBanner
})

const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const activeTab = ref('background')
const isScrollingProgrammatically = ref(false) // 添加标志，防止程序滚动时覆盖activeTab
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  
  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  
  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true
  
  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  
  // 滚动完成后，重置标志，允许IntersectionObserver再次工作
  setTimeout(() => {
    isScrollingProgrammatically.value = false
    // 确保滚动后activeTab正确
    updateActiveTab()
  }, 800) // 减少时间，从1000ms改为800ms
}
const animationObserver = ref(null)
const navObserver = ref(null) // 添加导航观察器
let scrollTimeout = null

const updateActiveTab = () => {
  // 如果是程序触发的滚动，不更新
  if (isScrollingProgrammatically.value) {
    console.log('Skipping update due to programmatic scroll')
    return
  }
  
  const sections = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  const scrollPosition = window.scrollY
  let newActiveTab = 'background'
  
  // 遍历所有区块，找出当前滚动位置对应的区块
  for (let i = 0; i < sections.length; i++) {
    const section = document.getElementById(sections[i])
    if (section) {
      const rect = section.getBoundingClientRect()
      const sectionTop = rect.top + window.scrollY
      const sectionBottom = sectionTop + rect.height
      
      // 如果当前滚动位置在区块范围内
      if (scrollPosition >= sectionTop - 150 && scrollPosition < sectionBottom - 150) {
        newActiveTab = sections[i]
        break
      }
    }
  }
  
  // 更新activeTab
  if (activeTab.value !== newActiveTab) {
    console.log('Updating activeTab from', activeTab.value, 'to', newActiveTab, 'scrollY:', scrollPosition)
    activeTab.value = newActiveTab
    history.replaceState(null, '', `#${newActiveTab}`)
  }
}

const handleScroll = () => {
  // 清除之前的定时器
  if (scrollTimeout) clearTimeout(scrollTimeout)
  
  // 设置新的定时器，延迟更新
  scrollTimeout = setTimeout(() => {
    console.log('Scroll event triggered, scrollY:', window.scrollY)
    updateActiveTab()
  }, 50)
}

// 添加一个立即执行的版本，用于测试
const handleScrollImmediate = () => {
  console.log('Scroll event triggered (immediate), scrollY:', window.scrollY)
  updateActiveTab()
}

// 使用IntersectionObserver来检测当前可见的区块
const setupIntersectionObserver = () => {
  // 创建观察器，设置阈值为0.5，表示当区块50%可见时触发
  navObserver.value = new IntersectionObserver((entries) => {
    // 如果是程序触发的滚动，不更新
    if (isScrollingProgrammatically.value) {
      console.log('IntersectionObserver: Skipping update due to programmatic scroll')
      return
    }
    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const sectionId = entry.target.id
        console.log('IntersectionObserver: Section', sectionId, 'is intersecting')
        
        // 更新activeTab
        if (activeTab.value !== sectionId) {
          console.log('IntersectionObserver: Updating activeTab from', activeTab.value, 'to', sectionId)
          activeTab.value = sectionId
          history.replaceState(null, '', `#${sectionId}`)
        }
      }
    })
  }, {
    threshold: 0.2, // 当区块20%可见时触发
    rootMargin: '-100px 0px -60% 0px' // 从顶部100px和底部60%的偏移
  })
  
  const sections = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  sections.forEach(sectionId => {
    const section = document.getElementById(sectionId)
    if (section) {
      navObserver.value.observe(section)
    }
  })
}

onMounted(() => {
  activeTab.value = 'background'
  console.log('Initial activeTab set to:', activeTab.value)
  
  // 延迟设置IntersectionObserver，确保DOM已完全加载
  setTimeout(() => {
    console.log('Setting up IntersectionObserver')
    setupIntersectionObserver()
    
    // 初始调用一次updateActiveTab
    console.log('Initial call to updateActiveTab')
    updateActiveTab()
  }, 300)
  
  // 创建动画观察器
  animationObserver.value = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const targetId = entry.target.id;
        if (targetId === 'background') backgroundVisible.value = true;
        if (targetId === 'challenges') challengesVisible.value = true;
        if (targetId === 'scenarios') scenariosVisible.value = true;
        if (targetId === 'architecture') architectureVisible.value = true;
        if (targetId === 'advantages') advantagesVisible.value = true;
        if (targetId === 'cases') casesVisible.value = true;
      }
    });
  }, {
    rootMargin: '-10% 0px -10% 0px',
    threshold: 0.1
  });

  // 观察所有区块元素
  const observeBlocks = () => {
    const blocks = document.querySelectorAll('.ai-platform-block');
    blocks.forEach(block => {
      animationObserver.value.observe(block);
    });
  };
  
  observeBlocks();
  
  // 添加滚动事件监听器作为备用方案
  console.log('Adding scroll event listener (immediate)')
  window.addEventListener('scroll', handleScrollImmediate, { passive: true })
})

onBeforeUnmount(() => { 
  // 清理IntersectionObserver
  if (navObserver.value) {
    console.log('Disconnecting navObserver')
    navObserver.value.disconnect()
  }
  
  if (animationObserver.value) animationObserver.value.disconnect()
  if (scrollTimeout) clearTimeout(scrollTimeout)
  window.removeEventListener('scroll', handleScrollImmediate)
  console.log('Scroll event listener removed (immediate)')
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(110deg, #eaf2ff 0%, #f7fbff 40%, #eef5ff 60%, #dfeaff 100%);
  overflow: hidden;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 360px at 75% 20%, rgba(24,144,255,0.18) 0%, rgba(24,144,255,0) 60%),
              radial-gradient(800px 300px at 20% 80%, rgba(64,158,255,0.20) 0%, rgba(64,158,255,0) 60%);
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.top_img {
  width: 100%;
  height: auto;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.top_img.show {
  opacity: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h2 {
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  color: #000;
  margin-bottom: 64px;
}

.adv-title {
  font-size: 18px;
  font-family: PingFang SC;
  color: var(--color-text);
  margin-bottom: 10px;
  font-weight: 600;
}

.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-secondary);
}

/* 专线安全页面滚动动画效果 */
.dedicated-line-security-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.dedicated-line-security-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.block-title {
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  color: #000;
  margin-bottom: 64px;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #F5F7FA;
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon {
  flex-shrink: 0;
}

.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.card-title {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #000000;
  line-height: 40px;
}

.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.scenarios {
  display: flex;
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  padding: 50px 0px 0px 40px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item {
  margin-bottom: 18px;
}

.scenario-item .item-title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFang SC;
}

.scenario-item .item-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.scenario-image {
  background-image: url('@/assets/jiejue/ai-tiaozhan/1.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.diagram {
  display: grid;
  gap: 12px;
}

.layer {
  background: #fff;
  border: 1px solid #e6ebf5;
  border-radius: 6px;
}

.layer-title {
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  background: #f6f9ff;
  border-color: #dfe8ff;
}

.layer-title.blue {
  background: #e8f2ff;
  border-color: #cfe0ff;
}

.grid.layer-app {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 12px;
}

.grid.layer-ml {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}

.grid.layer-data {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}

.grid.layer-infra {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}

.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div {
  background: #f9fbff;
  border: 1px dashed #e1e9ff;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  font-size: 13px;
}

.advantages {
  background-color: #f0f5ff;
}

.adv-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.adv-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.adv-badge {
  width: 40px;
  height: 40px;
  margin-bottom: 15px;
}

@media (max-width: 1200px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .scenarios {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .product-body {
    padding: 0 16px 40px;
  }
  
  .block {
    padding: 56px 5%;
  }
  
  .grid-2 {
    grid-template-columns: 1fr;
  }
  
  .grid-4 {
    grid-template-columns: 1fr;
  }
  
  .scenarios {
    flex-direction: column;
  }
  
  .card {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .product-tabs-bar {
    gap: 20px;
  }
}

#scenarios {
  max-width: unset;
  background: #F5F7FA;
}

#advantages {
  background: linear-gradient(180deg, #F5F7FA 0%, #E0ECFF 100%);
  max-width: unset;
}

.advantages .grid-4 {
  align-items: stretch;
  gap: 20px;
  max-width: 1770px;
  margin: 0 auto;
}

.adv-card {
  min-height: 240px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}

.adv-badge {
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #1890FF;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}
</style>

